(ns ui.gallery.folder-delete
  "The message of the folder delete confirmation of the Replicant
   gallery: a short overview of what the deletion will affect. The
   folder and its subfolders get deleted, while the items inside them
   are moved back to the main gallery by default (the
   `:command/folder-delete` command only retracts the folder entities,
   whereby the story medias lose their `:story-media/folder`). A
   checkbox lets the user opt in to also delete the items.")

(defn count-str
  [n singular]
  (str n
       " "
       singular
       (when (not= 1 n)
         "s")))

(defn total-item-count
  [preview]
  (+ (or (:folder/item-count preview) 0)
     (or (:folder/subfolder-item-count preview) 0)))

(defn message
  "The hiccup of the confirmation message for the folder `name` and the
   `preview` counts of `:query/gallery-folder-delete-preview`. Falls
   back to a plain question without a preview."
  [name preview]
  (if-not (:folder/item-count preview)
    [:p (str "Do you want to delete the folder '"
             name
             "'?")]
    (let [{:keys [folder/item-count
                  folder/subfolder-count
                  folder/subfolder-item-count]} preview
          total (total-item-count preview)]
      [:div.flex.flex-col.gap-3
       [:div
        [:p "This will delete:"]
        [:ul.list-disc.list-inside
         [:li (str "the folder '"
                   name
                   "' with "
                   (count-str item-count "item")
                   " inside")]
         (when (pos? subfolder-count)
           [:li (str (count-str subfolder-count "subfolder")
                     " with "
                     (count-str subfolder-item-count "item")
                     " inside")])]]
       (when (pos? total)
         [:p (str "The "
                  (count-str total "item")
                  " will be moved back to the main gallery.")])])))

(defn checkbox-label
  "The label of the 'delete the items too' checkbox, or nil when the
   folder tree is empty."
  [preview]
  (let [total (total-item-count preview)]
    (when (pos? total)
      (str "Delete the "
           (count-str total "item")
           " permanently instead"))))
